import { HttpParams } from '@angular/common/http';

type QueryParamValue = string | number | boolean | null | undefined;

export function toHttpParams<T extends Record<string, QueryParamValue>>(filters: T): HttpParams {
  return Object.entries(filters).reduce(
    (params, [key, value]) => (value == null ? params : params.set(key, String(value))),
    new HttpParams(),
  );
}
